import type { Resource } from '../../';
export const header_utilBar_viewMoreCountries: Resource = {"default":"View More Countries"};
